
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saskatchewan",
      function () {
        return require("private-next-pages/saskatchewan.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saskatchewan"])
      });
    }
  